export interface PriorityProps {
  priority?: 'primary' | 'secondary',
}

export const buttonTheme = {
  primary: 'px-6 py-1 bg-unaula-orange rounded-3xl text-[#fff] text-center',
  secondary: 'px-6 py-1 bg-unaula-red rounded-3xl text-[#fff] text-center',
};
